import { Box } from '@monorepo/nova-ui';
import { styled } from '@mui/material/styles';

export const ButtonsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(3),
  width: '100%',

  '& .MuiButton-root': {
    height: theme.spacing(12),
    borderRadius: theme.customShape.borderRadius4XL,
    textTransform: 'none',
    fontSize: theme.typography.body1.fontSize,
    fontWeight: theme.typography.fontWeightMedium,
    flex: 1,
  },

  '& .MuiButton-outlined': {
    borderColor: theme.palette.primary.main,
    color: theme.palette.primary.main,
    order: 1,
    '&:hover': {
      borderColor: theme.palette.primary.dark,
      backgroundColor: theme.palette.action.hover,
    },
  },

  '& .MuiButton-primary, & .MuiButton-contained': {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    boxShadow: 'none',
    order: 2,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
      boxShadow: 'none',
    },
  },

  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    gap: theme.spacing(1.5),

    '& .MuiButton-outlined': {
      order: 2,
    },

    '& .MuiButton-primary, & .MuiButton-contained': {
      order: 1,
    },

    '& .MuiButton-root': {
      height: `${theme.spacing(12)} !important`,
      fontSize: theme.typography.pxToRem(16),
      padding: `${theme.spacing(3, 7)} !important`,
    },
  },
}));
